import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import TableSkeleton from "../../StyledComponents/TableSkeleton";
import EmptyData from "../../StyledComponents/Table/EmptyData";
import { getBankDetail, getBatchbyLCId } from "./actions";
import moment from "moment";
import { getBankName } from "../../Functions/functions";

const useStyles = makeStyles({
  iconButton: {
    visibility: "hidden",
    fontSize: "14px",
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "#e4e7e6",
    },
  },
  // tableCell: {
  //   position: "relative",
  //   cursor: "pointer",
  //   "&:hover  $iconButton": {
  //     visibility: "visible",
  //   },
  // },
  iconButtonActive: {
    position: "absolute",
    top: "50%",
    fontSize: "14px",
    transform: "translateY(-50%)",
    visibility: "visible",
    cursor: "pointer",
  },
  table: {
    // width: 0,
    minWidth: "100%",
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    
  },
  inputStyle: {
    outline: "none",
    border: "none",
    background: "transparent",
  },
  inputHov: {
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
  },
  tabCon: {
      width: "max-content !important",
      textAlign: "center",
  },
  
});
const VendorFinancingLCTable = ({
  formState,
  setFormState,
  loading,
  lcList,
}) => {
  const [headers, setHeaders] = useState({});
  const [bankDetails, setBankDetails] = useState([]);
  const [bankDetailsLoading, setBankDetailsLoading] = useState(false);
   const [detail, setDetail] = useState([]);
   const [batches , setBatch] = useState([])
  const classes = useStyles();
  const isAscending = (value) => {
    setFormState((formState) => ({
      ...formState,
      isAsc: value,
    }));
  };

  useEffect(() => {
    if (lcList?.length > 0) {
      const obj = {};
      const object = lcList[0];
      for (const property in object) {
        const name = property.replace(/\s/g, "");
        obj[name] = property;
      }

      setHeaders(obj);
    }
  }, [lcList]);
  useEffect(() => {
    getBankDetail(null, setBankDetails, setBankDetailsLoading);
  }, []);


console.log(batches, "batches")


// getBatchbyLCId("72")


const show = (lcId) => {

setBatch([])
  let data = detail.filter((i) => i === lcId);

  if (data.length > 0) {
    setDetail(detail.filter((i) => i != lcId));
  } else {
    setDetail([ lcId]);
  }
  getBatchbyLCId(lcId , setBatch)
  // detail === position ? setDetail(false) : setDetail(position);
};




  return (



      <>
      
      <TableContainer   className={`${classes.tabCon} `}>
        <Table   className={classes.table}         size="small" >
          <TableHead style={{ position: "sticky", top: -2, zIndex: "1" }}>
            <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
              <TableCell
               sx={{ fontWeight: "bold", color: "#031C30"  }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(
                    (formState) => (
                     
                      {
                        ...formState,
                        isAsc: !formState?.isAsc,
                      }
                    )
                  );
                }}>
                <span className={classes.tableCell} sx = {{backgroundColor : "#85ADC2",}}>S.#</span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
               
                  isAscending(!formState?.isAsc);
                  setFormState(
                    () => (
                     
                      {
                        ...formState,
                        // OrderBy: "invoice_id",
                        isAsc: !formState?.isAsc,
                      }
                    )
                  );
                  // Sorting(headers.InvoiceNo);
                }}>
                <span className={classes.tableCell}>
                  Vendor Code
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.vendor_Code
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.vendor_Code
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
               
                  isAscending(!formState?.isAsc);
                  setFormState(
                    () => (
                     
                      {
                        ...formState,
                        // OrderBy: "invoice_id",
                        isAsc: !formState?.isAsc,
                      }
                    )
                  );
                  // Sorting(headers.InvoiceNo);
                }}>
                <span className={classes.tableCell}>
                  Vendor Name
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.vendor_Name
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.vendor_Name
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  Bank Name
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.bank_Id
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.bank_Id
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  LC/Bank Reference no
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers?.
                        lC_Bank_Reference_num
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.lC_Bank_Reference_num
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  LC Amount
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.lC_Amount
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.lC_Amount
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
             
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  Utilized
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.utilizes_Amount
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.utilizes_Amount
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  {" "}
                  Available Amount
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.available_Amount
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.available_Amount
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  {" "}
                  Maturity Period
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.maturity_Period
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.maturity_Period
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  {" "}
                  Issuance Date{" "}
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.issuance_Date
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.issuance_Date
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}{" "}
                </span>
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", color: "#031C30" }}
                onClick={() => {
                  isAscending(!formState?.isAsc);
                  setFormState(() => ({
                    ...formState,
                    isAsc: !formState?.isAsc,
                  }));
                }}>
                <span className={classes.tableCell}>
                  {" "}
                  Expiry Date{" "}
                  {formState.isAsc ? (
                    <ArrowUpwardIcon
                      className={`${
                        formState.OrderBy === headers.expiry_Date
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className={`${
                        formState.OrderBy === headers.expiry_Date
                          ? classes.iconButtonActive
                          : classes.iconButton
                      }`}
                    />
                  )}
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          {loading ? (
            <TableSkeleton
              style={{ width: "100%" }}
              noOfColumns={10}
              noOfLines={5}
              flag={true}
            />
          ) : 
          <TableBody>
           
           {lcList?.length > 0 &&
              lcList?.map((item, index) => {
                return (
                 <>
                  <TableRow >
                    <TableCell  sx={{
    padding: "11px 21px", 

    backgroundColor : "#85ADC2",
    "&:hover": { cursor: "pointer" } 
   
  }} onClick={() => show(item?.["lC_Id"])}>{index + 1}</TableCell>
                    <TableCell  sx={{
    padding: "11px 21px",
    
 
  }}
  
  
  >{item?.["vendor_Code"]}</TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>{item?.["vendor_Name"]}</TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>
                      {getBankName(bankDetails, item?.["bank_Id"])}
                    </TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>{item?.["lC_Bank_Reference_num"]}</TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>{Number(item?.["lC_Amount"])?.toLocaleString()}</TableCell>
  
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>{Number(item?.["utilizes_Amount"])?.toLocaleString()}</TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>{Number(item?.["available_Amount"])?.toLocaleString()}</TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>{item?.["maturity_Period"]}</TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>
                      {moment(item?.["issuance_Date"]).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell sx={{
    padding: "11px 21px",
    
 
  }}>
                      {" "}
                      {moment(item?.["expiry_Date"]).format("DD-MM-YYYY")}{" "}
                    </TableCell>
                  </TableRow>
                 
           {detail.some((arrVal) => item?.["lC_Id"] === arrVal) ? (
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Table
                             style={{ margin: "20px 0px" }}
                             aria-label="a dense table"
                             size="small"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                                <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      width: "10%",
                                      
                                    }}
                                  >
                                    S.#
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      width: "10%",
                                    }}
                                  >
                                    Batch No
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      
                                      width: "10%",
                                    }}
                                  >
                                    Batch Date
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30"
                                      ,
                                      width: "10%",

                                    }}
                                  >
                                    Maturity Date
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      width: "10%",
                                    }}
                                  >
                                    Vendor
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      width: "10%",
                                    }}
                                  >
                                  No of Invoices
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      width: "10%",
                                    }}
                                  >
                                    Batch Amount
                                  </TableCell>
                                 
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {batches?.map((item, index) => (
                                  <TableRow
                                    style={{ cursor: "pointer" }}
                                    className={classes.tableRow}
                                   
                                    key={index}
                                  >
<TableCell
                                      style={{ color: "black" , marginLeft :"20px" }}
                                    >
                                      {index+1}
                                    </TableCell>
                                   
                               
                                    <TableCell
                                      style={{ color: "black", width: "10%" , marginLeft :"20px"}}
                                    >
                                      {item?.batchRef}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                     {item?.batchDate &&
                                                                moment(item?.batchDate).format("DD-MMM-YYYY")}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                     {item?.maturityDate &&
                                                                moment(item?.maturityDate).format("DD-MMM-YYYY")}
                                    </TableCell>

                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {item?.vendor_Name}
                                    </TableCell>
                                    
                                    <TableCell
                                      style={{ color: "black", width: "15%" }}
                                    >
                                      {item?.noOfInvoices}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "15%" }}
                                    >
                                      {item?.batchAmount}
                                    </TableCell>
                                   
                                   
                                  </TableRow>
                                ))}
                              </TableBody>
                              {/* {item.invoiceDetail?.length === 0 ? (
                              <>
                                <EmptyData />
                              </>
                            ) : (
                              ""
                            )} */}
                            </Table>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
          
                 </>

                  
                );
              })}
         

           
          </TableBody>
}
        </Table>
      </TableContainer>
      {lcList?.length === 0 && !loading ? (
        <EmptyData />
      ) : Object.keys(headers).length === 0 && loading ? (
        <TableSkeleton
          style={{ width: "100%" }}
          noOfColumns={10}
          noOfLines={5}
          flag={true}
        />
      ) : (
        ""
      )}

</>
    
  );
};

export default VendorFinancingLCTable;
